export const OWNER_PAGE_PATH = "/owner";

export const OwnerPage = () => {
  return (
    <div>
      <h1>OwnerPage</h1>
    </div>
  );
};
